"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppendCss;
// inserts supplied `css` into the head tag, if not there already based on `id`
function AppendCss(id, css, insertTop) {
  let headElem = document.getElementsByTagName("head")[0];
  if (!headElem.querySelector('style[id="' + id + '"]')) {
    let _CSS = "";
    if (typeof css === "string") {
      _CSS = css;
    } else if (typeof css === "object") {
      css.forEach(function (item, index) {
        _CSS += item;
      });
    }
    // insert the style into the head
    let tag = document.createElement("style");
    tag.id = id;
    tag.innerHTML = _CSS;
    tag.type = "text/css";
    if (insertTop) {
      headElem.insertBefore(tag, headElem.firstChild);
    } else {
      headElem.appendChild(tag);
    }
  }
  return;
}